import { PuffLoader } from "react-spinners"

const Loader = () => {
  return (
    <div className="h-screen w-full flex items-center justify-center">
      <PuffLoader className="text-primary size-32" color="#F95816"/>
    </div>
  );
};

export default Loader;